// extracted by mini-css-extract-plugin
export default {"wrapper":"BankTransfer_wrapper__c6+tR"};